import React from 'react';
import PropTypes from 'prop-types';
import CustomTooltip from '../../../Tooltip';
import CSV from '../../../../utils/CSV/index';
import config from '../../../../config.js';
import { withTemplateConfig } from '../../../../context/TemplateConfigContext';

const csv = new CSV();

class StatisticsByReferralCSV extends React.Component {
    constructor(props) {
        super();
        this.onDownload = this.onDownload.bind(this);
    }

    getData() {
        let data = this.props.data;
        data.unshift(this.props.headerName);
        return data;
    }

    onDownload() {
        let data = csv.convert(this.getData());
        csv.download(data, config.reportByReferralFileNameCSV);
    }

    render() {
        const staticNames = this.context.t.reportPage;
        const { templateConfig } = this.props;

        return (
            <CustomTooltip id={`statistics-csv`} tooltip={staticNames.downloadCSV}>
                <a
                    className="btn"
                    id="statisticReport"
                    onClick={this.onDownload}
                >
                    <img src={templateConfig.assets.icons.downArrow} alt=""/>
                </a>
            </CustomTooltip>
        );
    }
}

StatisticsByReferralCSV.propTypes = {
    data: PropTypes.array,
    headerName: PropTypes.array,
    templateConfig: PropTypes.object,
};

StatisticsByReferralCSV.defaultProps = {
    data: [],
    headerName: [],
};

StatisticsByReferralCSV.contextTypes = {
    t: PropTypes.object
};

export default withTemplateConfig(StatisticsByReferralCSV);